/**
 * Lista estrutura de pastas
 */
export const folders = [
    {
        folder: '/',
        description: 'Pasta principal (raiz) da aplicação.'
    },
    {
        folder: '/public',
        description: 'Pasta para arquivos estáticos (públicos) não compilados no build.'
    },
    {
        folder: '/src',
        description: 'Pasta exclusiva para todo o código fonte.'
    },
    {
        folder: '/src/assets',
        description: 'Pasta para arquivos estáticos compilados no build.'
    },
    {
        folder: '/src/components',
        description: 'Pasta para manter os componentes específicos para aplicação.'
    },
    {
        folder: '/src/domains',
        description: 'Pasta para manter os recursos específicos de cada área (modulo) do sistema.'
    },
    {
        folder: '/src/locales',
        description: 'Pasta para manter os arquivos específicos de tradução da aplicação.'
    },
    {
        folder: '/src/themes',
        description: 'Pasta para manter os temas da aplicação.'
    },
    {
        folder: '/src/plugins',
        description: 'Pasta para manter os componentes externos utilizados pelo sistema.'
    },
    {
        folder: '/src/plugins/i18n',
        description: 'Integração da lib de tradução para os principais idiomas e componentes do vuetify.'
    },
    {
        folder: '/src/plugins/vuetify',
        description: 'Framework principal de componentes do material design.'
    },
    {
        folder: '/src/plugins/xtpgui',
        description: 'Concentra todos os componentes e utilitários da lib, evite mudanças aqui durante o desenvolvimento do projeto.'
    },
    {
        folder: '/src/plugins/xtpgui/components',
        description: 'Componentes (inputs, widgets, data grid, etc) todos estão concentrados aqui.'
    },
    {
        folder: '/src/plugins/xtpgui/directives',
        description: 'Diretivas são modificadores úteis para elementos visuais (forms, inputs, etc.).'
    },
    {
        folder: '/src/plugins/xtpgui/filters',
        description: 'Filtros úteis para converter valores (forms, inputs, etc.).'
    },
    {
        folder: '/src/plugins/xtpgui/docs',
        description: 'Páginas (views) da documentação e demonstração.'
    },
    {
        folder: '/src/plugins/xtpgui/routes.js',
        description: 'Rotas específicas para documentação e demonstração.'
    },
    {
        folder: '/src/plugins/xtpgui/store.js',
        description: 'Store específicas para os componentes da xtpg-ui.'
    },
    {
        folder: '/src/startup',
        description: 'Pasta para manter os inicializadores do sistema (evitar mudanças).'
    },
    {
        folder: '/src/main.js',
        description: 'Responsável por inicializar a aplicação.'
    },
    {
        folder: '/src/routes.js',
        description: 'Responsável por carregar as rotas da aplicação.'
    },
    {
        folder: '/src/store.js',
        description: 'Responsável por carregar o vuex da aplicação, utilize para importar suas stores aqui.'
    },
];

export default {
    folders,
};
